<template>
  <base-section
    id="story"
    space="56"
    class="grey lighten-4"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="12"
        >
          <base-business-info title="SEKILAS TENTANG KAMI" text="Keinginan membentuk asuransi syariah di Indonesia sebenarnya sudah muncul sejak lama sebelum berdirinya bank syariah pertama, Bank Muamalat. Tekad itu semakin kuat manakala Bank Muamalat sudah benar-benar resmi beroperasi pada tanggal 1 Mei 1992. Baru pada tanggal 27 Juli 1993, para wakil dari Yayasan Abdi Bangsa, Bank Muamalat Indonesia, dan Asuransi Jiwa Tugu Mandiri, sebagai sponsor Team Pembentukan Asuransi Takaful Indonesia (TEPATI), berkumpul guna mewujudkan harapan besar tersebut. Team ini juga mendapat dukungan dari beberapa pejabat Departemen Keuangan dan sejumlah pengusaha muslim Indonesia.">
          </base-business-info>
          <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="accent"
              large
              outlined
              to="sejarah-takaful"
              class ="text-capitalize"
            >
              Baca selengkapnya
            </base-btn>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionStory',
  }
</script>
